import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAPI } from 'data/api';

/**
 * List all installations for a project
 * @returns installations
 */
export const useListAllInstallations = () => {
  const getAPI = useAPI();
  const { projectId } = useParams();


  return useQuery({
    queryKey: ['listAllInstallations', projectId],
    queryFn: async () => {
      if (!projectId) throw new Error('projectId is required');
      const api = await getAPI();
      
      // Fetch installations for each integration
      const installations = await api.installationApi.listInstallationsForProject({ 
        projectIdOrName: projectId,
      });

      return installations;
    },
    enabled: !!projectId,
  });
};
